function handleSkipLink() {
  const skipLink = document.getElementById('skip-link');
  const mainContent = document.getElementById('main-content');

  if (!skipLink || !mainContent) return;

  skipLink.addEventListener('click', (e) => {
    e.preventDefault();
    mainContent.focus();
  });
}

window.addEventListener('load', handleSkipLink);
